module.exports = __webpack_public_path__ + "assets/img/Benefits.d2afbcce.svg";